import {Post} from "../../../types/Post";

export const filterPostByKeyword = (posts: Post[], keyword: string) => {
  if (!posts) return []
  if (posts.length === 0) return []

  return posts.filter(post => {
    const trimmedKeyword = keyword.trim();
    return (
      (trimmedKeyword === ''
        || post?.title?.includes(trimmedKeyword)
        || post?.content?.includes(trimmedKeyword)
      )
    )
  })
}